'use client'

import { TopNavProvider } from '@src/components/TopNavV3/TopNavContext'

import { defaultTopNavProps } from './TopNav.defaults'
import { TopNavDesktop } from './TopNavDesktop/TopNavDesktop'
import { TopNavMobile } from './TopNavMobile/TopNavMobile'
import { type TopNavProps } from './TopNavProps'

export const TopNavV3 = (props: TopNavProps = defaultTopNavProps) => {
  return (
    <TopNavProvider topNavProps={props}>
      <TopNavMobile />
      <TopNavDesktop />
    </TopNavProvider>
  )
}
